
// packages
import React, { useState,useEffect } from 'react';
import { Box, Typography, Stack, Button, Modal, TextField } from '@mui/material'
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useMediaQuery } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'

// local
import deleteTimeslot from '../helpers/deleteTimeSlot';
import { deleteScheduledTesters } from '../helpers/requestScheduledTesters';
import { putScheduledTesters, postScheduledTesters } from '../helpers/requestScheduledTesters';
import ConfirmActionModal from './ConfirmActionModal';
import { usePostUserMutation } from '../../api';
import { useSystemMessage } from '../../providers/SystemMessageContext';
import LoadingTakeover from '../buffers/LoadingTakeover';

const ScheduledTestersModal = ({scheduled_testers, time_slot, time_slot_id, handleClose, refreshHook=null, extraClose=null, onRowClick}) => {
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const isMobile = useMediaQuery("(max-width:600px)");
    const { showMessage } = useSystemMessage();

    const scheduledTesters = scheduled_testers
    //console.log(scheduledTesters);
    const { submit:triggerUserMutation, data:userMutation, error:userMutationError, isMutating: isPostingTokens } = usePostUserMutation();

    useEffect(() => {
        if (userMutation) {
            showMessage(userMutation.message, userMutation.success ? "success" : "error");
        } else if (userMutationError) {
            showMessage(userMutationError.response.data.message, userMutationError.response.data.success ? "success" : "error");
        }
    }, [userMutation, userMutationError]);

    const handleGrantTokens = async () => {
        await triggerUserMutation({
            "grant_exam_tokens": {
                "test_taker_ids": selectedIds,
                "exam_token_quantity": tokensToGrant
            }
        }).catch((error) => {
            return;
        });
    };
    
    const [userToRemove, setUserToRemove] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);
    const [tokensToGrant, setTokensToGrant] = useState(0);

    const paginationModel = { page: 0, pageSize: 5 };
    const gridRows = scheduledTesters;
    const gridColumns = [
        { headerName: 'ID', field: 'id'},
        { flex:1, headerName: 'Test Taker', field: 'test_taker'},
        { flex:1, headerName: 'First Name', field: 'first_name'},
        { flex:1, headerName: 'Last Name', field: 'last_name'},
        { flex:2.5, headerName: 'Components', field: 'component_type', editable: true},
        { flex:2.5, headerName: 'Notes', field: 'notes', editable: true},
        { flex:1, headerName: 'Time Slot', field: 'time_slot'},
        {
            field: 'profile',
            headerName: '',
            width:60,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <IconButton
                    onClick={(e) => {
                        e.stopPropagation();
                        onRowClick(params);
                    }}
                    aria-label="view answers"
                >
                    <VisibilityIcon />
                </IconButton>
            )
        },
        {
            field: 'view',
            headerName: '',
            width:60,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => (
                <IconButton
                    onClick={(e) => {
                        e.stopPropagation(); // Prevent row selection
                        setUserToRemove(params.row.id);
                        toggleOpenSecondConfirmation();
                    }}
                >
                    <DeleteIcon />
                </IconButton>
            )
        },
      ];

    const [addTesterOpen, setAddTesterOpen] = useState(false);
    const toggleAddTesterOpen = () => setAddTesterOpen(!addTesterOpen);
    const [userId, setUserId] = useState(null);
    const [components, setComponents] = useState(null);

    const [rowUpdates, setRowUpdates] = useState({});
    const handleSaveChanges = async () => {
        const updates = Object.values(rowUpdates);
        try {
            for (const update of updates) {
                putScheduledTesters(update.time_slot, update.test_taker, update.component_type, update.id);
            }
            setRowUpdates({});
            alert('Changes saved!');
        } catch (error) {
            console.error(error);
            alert('Failed to save changes.');
        }
    };

    const [openConfirmAction, setOpenConfirmAction] = useState(false);
    const toggleOpenConfirmAction = () => setOpenConfirmAction(!openConfirmAction);

    const [canProceed, setCanPoceed] = useState(false);
    useEffect(() => {
        if (canProceed) {
            deleteTimeslot(time_slot_id);
            handleClose();
            setCanPoceed(false);
            extraClose && extraClose();
        };
    },[canProceed, setCanPoceed, handleClose, time_slot_id, extraClose]);

    const [openSecondConfirmation, setOpenSecondConfirmation] = useState(false);
    const toggleOpenSecondConfirmation = () => setOpenSecondConfirmation(!openSecondConfirmation);
    const [canProceedSecond, setCanProceedSecond] = useState(false);
    useEffect(() => {
        if (canProceedSecond) {
            deleteScheduledTesters(userToRemove);
            if (refreshHook) {
                refreshHook();
            }
            handleClose();
        };
    },[canProceedSecond, setCanProceedSecond, userToRemove, handleClose, refreshHook]);
    
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // STYLES 
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '95vw',
        minWidth:'75vw',
        maxHeight: '95vh',
        overflowY: 'auto',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
    }
    const mobileModalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '65vw',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
    }

    const gridStyle = {m:1, mb:3, borderRadius:4, cursor:'pointer'}

    return (
        <>
            <Modal
                open={openConfirmAction}
                onClose={toggleOpenConfirmAction}
            >
                <ConfirmActionModal
                    actionString={'delete this timeslot'}
                    handleClose={toggleOpenConfirmAction}
                    confirmationHook={setCanPoceed}
                />
            </Modal>
            <Modal
                open={openSecondConfirmation}
                onClose={toggleOpenSecondConfirmation}
            >
                <ConfirmActionModal
                    actionString={'remove this test taker'}
                    handleClose={toggleOpenSecondConfirmation}
                    confirmationHook={setCanProceedSecond}
                />
            </Modal>
            <Modal
                open={addTesterOpen}
                onClose={toggleAddTesterOpen}
            >
                <Box sx={!isMobile ? (modalStyle) : (mobileModalStyle)}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{fontWeight:600}}>
                        Add Tester to <Typography variant='h5' sx={{ fontWeight:600, color:'#1483FA', display:'inline-block'}}>{time_slot}</Typography>
                    </Typography>
                    <Stack spacing={2} sx={{ mt:2, mb: 2 }}>
                        <TextField
                            label="User ID"
                            value={userId}
                            type='number'
                            onChange={(e) => setUserId(e.target.value)}
                            fullWidth
                        />
                        <TextField
                            label="Components"
                            value={components}
                            onChange={(e) => setComponents(e.target.value)}
                            fullWidth
                        />
                        <Button
                            variant='contained'
                            onClick={() => {
                                postScheduledTesters(time_slot_id, userId, components)
                                toggleAddTesterOpen();
                                handleClose();
                            }}
                        >
                            Submit
                        </Button>
                    </Stack>
                </Box>
            </Modal>
            <Box sx={!isMobile ? (modalStyle) : (mobileModalStyle)}>
                <Stack direction={"row"} sx={{mb:2, justifyContent:"space-between"}}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{fontWeight:600}}>
                        Scheduled Testers for <Typography variant='h5' sx={{ fontWeight:600, color:'#1483FA', display:'inline-block'}}>{time_slot}</Typography>
                    </Typography>
                    <Button 
                        variant='outlined' 
                        sx={{
                            "&:hover": { backgroundColor: "#c44601", color:"#FFFFFF", borderColor:"#FFFFFF"}
                        }}
                        onClick={() => {
                            toggleOpenConfirmAction();
                        }}
                    >
                        Delete Timeslot
                    </Button>
                </Stack>
                <DataGrid
                    sx={gridStyle}
                    rows={gridRows}
                    columns={gridColumns}
                    checkboxSelection
                    initialState={{ 
                        pagination: { paginationModel },
                        columns: {
                            columnVisibilityModel: {
                                id: false,
                                time_slot: false,
                            }
                        }
                    }}
                    onRowSelectionModelChange={(newSelection) => {
                        // selected row IDs
                        setSelectedIds(newSelection);

                        // map IDs → full row data
                        const selectedRows = newSelection
                            .map(id => gridRows.find(r => r.id === id))
                            .filter(Boolean);

                        // extract the test_taker field
                        const selectedTestTakers = selectedRows.map(r => r.test_taker);
                        setSelectedIds(selectedTestTakers);
                    }}
                    disableRowSelectionOnClick
                    processRowUpdate={(newRow) => {
                        setRowUpdates(prev => ({
                            ...prev,
                            [newRow.id]: newRow,
                        }));
                        return newRow;
                    }}
                />
                { 
                    selectedIds.length > 0 ? (
                        <Stack direction={'row'} gap={1}>
                            <Button 
                                variant="contained" 
                                sx={{mb:1, alignSelf: 'center' }}
                                onClick={handleGrantTokens}
                            >
                                Grant Tokens to Selected Users
                            </Button>
                            <TextField
                                id='outlined-number'
                                label='Add Tokens'
                                type='number'
                                slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                                }}
                                onChange={(e) => setTokensToGrant(e.target.value)}
                            />
                        </Stack> 
                    ) : isPostingTokens ? (<LoadingTakeover />) : (<></>)
                }
                <Stack direction={'row'} sx={{p:0, justifyContent:'space-between'}}>
                    <Button variant='outlined' sx={{}} onClick={() => handleClose()}>Cancel</Button>
                    <Stack direction={'row'} spacing={1}>
                        <Button variant='contained' sx ={{}} onClick={() => {
                            toggleAddTesterOpen();
                        }}>
                            Add Tester +
                        </Button>
                        <Button
                            variant='contained'
                            color='success'
                            onClick={handleSaveChanges}
                            disabled={Object.keys(rowUpdates).length === 0}
                        >
                            Save Changes
                        </Button>
                    </Stack>
                </Stack>
            </Box>
        </>
    );
}

export default ScheduledTestersModal;